export default "__VITE_ASSET__yHEBJa5M__"